module.exports = __webpack_public_path__ + "img/42.7f513045.png";